if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        zoomIsOpen: false,
        productMediaIsOpen: '',
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        splideInstance: null,

        // ✅ IMPORTANT: REAL slides only (fix index mismatch)
        getSlides() {
          const root = document.querySelector(
            `#x-product-template--${settings.section_id}__main`
          );

          if (!root) return [];

          return Array.from(
            root.querySelectorAll('.splide__slide')
          );
        },

        init() {
          this.$nextTick(() => {
            const el = document.querySelector(
              `#x-product-template--${settings.section_id}__main`
            );

            if (el && el.splide) {
              this.splideInstance = el.splide;
            }

            // 🔥 fallback: ensure splide loads late
            setTimeout(() => {
              if (!this.splideInstance && el && el.splide) {
                this.splideInstance = el.splide;
              }
            }, 500);
          });
        },

        // =========================
        // ✅ FIXED MEDIA CHANGE
        // =========================
        changeMediaByIndex(index) {
          const i = parseInt(index, 10);

          const el = document.querySelector(
            `#x-product-template--${settings.section_id}__main`
          );

          if (!el) return;

          // refresh instance always safe
          if (!this.splideInstance && el.splide) {
            this.splideInstance = el.splide;
          }

          const slides = this.getSlides();

          // safety check
          if (!slides.length) return;

          // 🧠 FIX: real index mapping (IMPORTANT)
          const targetSlide = slides[i];

          // 1. TRY SPLIDE API
          if (this.splideInstance && typeof this.splideInstance.go === 'function') {
            this.splideInstance.go(i);
            return;
          }

          // 2. fallback: manual scroll
          if (targetSlide) {
            targetSlide.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          }
        },

        // =========================
        // ZOOM LOGIC
        // =========================
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },

        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition =
              ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition =
              ((event.clientY - this.yOffset) / this.imageHeight) * 100;
          }
        },

        // =========================
        // THUMBNAIL DRAG
        // =========================
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';

          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
          }
        },

        thumbnailHandleMouseMove(e) {
          if (!this.thumbnailOnMouseDown) return;

          e.preventDefault();

          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2;
            this.$refs.thumbnail.scrollLeft =
              this.thumbnailScrollOfset - walk;
          } else {
            const y = e.pageY - this.$refs.thumbnail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2;
            this.$refs.thumbnail.scrollTop =
              this.thumbnailScrollOfset - walk;
          }
        },

        thumbnailHandleMouseLeave() {
          this._thumbnailRemoveGrabing();
        },

        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },

        _thumbnailRemoveGrabing() {
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
        },

        // =========================
        // ZOOM
        // =========================
        zoomOpen(position, isSplide) {
          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;

          setTimeout(() => {
            const splideEl = document.getElementById(
              `media-gallery-${settings.section_id}`
            );

            if (isSplide && splideEl && splideEl.splide) {
              const slides = Array.from(
                splideEl.querySelector('.splide__list').children
              ).filter(el => el.classList.contains('splide__slide'));

              let nextSlideIndex = 0;

              slides.forEach((item, index) => {
                if (item.getAttribute('x-slide-index') == position) {
                  nextSlideIndex = index;
                }
              });

              splideEl.splide.go(nextSlideIndex);
            } else {
              const el = document.getElementById(
                position + '-image-zoom-' + settings.section_id
              );

              if (el) {
                el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              }
            }
          }, 200);

          Alpine.store('xModal').activeElement =
            'product-image-' + settings.section_id + '-' + position;
        },

        zoomClose() {
          this.zoomIsOpen = false;
          Alpine.store('xPopup').close();
        },

        // =========================
        // VIDEO + MODEL (UNCHANGED SAFE)
        // =========================
        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },

        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },

        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((el) => {
              window.ShopifyXR.addModels(JSON.parse(el.textContent));
              el.remove();
            });
            window.ShopifyXR.setupXRElements();
          };

          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', setup);
            return;
          }

          setup();
        },

        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');

          content.appendChild(
            container.querySelector('template').content.firstElementChild.cloneNode(true)
          );

          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));

          this._productModelLoadViewerUI();
        },

        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },

        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },

        _productModelSetupViewerUI(errors) {
          if (errors) return;

          this.$el.parentNode.modelViewerUI =
            new Shopify.ModelViewerUI(
              this.$el.parentNode.querySelector('model-viewer')
            );
        },
      }));
    });
  });
}

function jumpToMediaIndex(index) {
  document.querySelectorAll('.media_clickchange_text').forEach(el => el.classList.remove('active'));
  document.querySelector(`.media_clickchange_text[data-index="${index}"]`)?.classList.add('active');

  const thumbnails = document.querySelectorAll(
    '.product__media-list .product__media-item, ' +
    '[data-media-id], ' +
    '.thumbnail-list__item, ' +
    '.product-media-modal__content li, ' +
    'ul.product__media-list > li'
  );

  if (thumbnails.length > 0 && thumbnails[index]) {
    const target = thumbnails[index];
    target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    target.click();
    const btn = target.querySelector('button, a');
    if (btn) btn.click();
    return;
  }
  const mediaList = document.querySelector(
    '.product__media-list, .splide__list, .swiper-wrapper, [data-product-media-list]'
  );

  if (mediaList) {
    const slides = mediaList.children;
    if (slides[index]) {
      slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      slides[index].dispatchEvent(new Event('click', { bubbles: true }));
    }
    return;
  }

  if (window.splide) {
    window.splide.go(index);
    return;
  }

  const gallery = document.querySelector('[x-data]');
  if (gallery && gallery.__x) {
    try {
      gallery.__x.$data.activeMediaIndex = index;
    } catch(e) {}
  }
}
document.addEventListener('DOMContentLoaded', function () {
  const firstBtn = document.querySelector('.media_clickchange_text[data-index="2"]');
  if (firstBtn) firstBtn.classList.add('active');
  document.querySelectorAll('.media_clickchange_text').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.media_clickchange_text').forEach(function (el) {
        el.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

});